export default "__VITE_ASSET__DBTRknNC__"